import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const Meta = () => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      document.title = "Pneumatic Conveying Systems | Ash Handling System"; // Reset title if necessary
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <Helmet>
      <title>Pneumatic Conveying Systems | Ash Handling System</title>
      <meta
        name="title"
        content="Pneumatic Conveying Systems | Ash Handling System"
      />
      <meta
        name="description"
        content="Pneumatic conveyors offer clean, dust-free operation with a long lifespan. Custom designs ensure trouble-free performance and reliable operation."
      />
      <meta name="keywords" content="Pneumatic Conveying Systems" />
      <meta name="robots" content="index,follow" />
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />

      <meta
        property="og:title"
        content="Unicon - Pneumatic Conveying Systems | Ash Handling System"
      />
      <meta
        property="og:site_name"
        content="Unicon Pneumatic Conveying Systems"
      />
      <meta
        property="og:url"
        content="https://www.uniconinter.com/pneumatic-conveying-system"
      />
      <meta
        property="og:description"
        content="Pneumatic conveyors offer clean, dust-free operation with a long lifespan. Custom designs ensure trouble-free performance and reliable operation."
      />
      <meta property="og:type" content="product" />
      <meta
        property="og:image"
        content="https://www.uniconinter.com/images/products/pneumatic-conveying-system/cutout1.jpg"
      />
    </Helmet>
  );
};

export default Meta;
